<template>
  <div>
    <div class="card-body pb-0" v-if="errors.length">
        <base-alert  type="danger" class="mb-0">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
    </div>
    <h2><span v-if="this.$attrs.actionStatus=='Edit'">Edit</span><span v-if="this.$attrs.actionStatus!='Edit'">Setup</span> product for Shopify
        <div class="float-right">
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-if="this.$attrs.actionStatus=='Edit'" :loading="saveLoading" @click.prevent="updateParams">Update</a-button>
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-else-if="this.$attrs.actionStatus!='Edit'" :loading="saveLoading" @click.prevent="saveParams">Save</a-button>
            <a-button type="primary" class="btn float-right mr-0 bg-white text-dark mr-3 btn-sm" @click.prevent="$emit('closeProductFrom', null)">Cancel</a-button>
        </div>
    </h2>
    <div class="row mt-4 overflow-auto" style="height: 44rem;">
        <div class="col-md-12">
            <a-collapse v-model="activeKey" expand-icon-position="right" class="border-0 bg-white">
                <a-collapse-panel key="1" header="01. Basic Information" :style="customStyle">
                    <base-input v-model="shopifyPayload.title" input-classes="form-control form-control-sm" label="Title" required />
                    <div class="form-group has-label"><label class="form-control-label">
                        Description</label>
                        <quill-editor
                            v-model="shopifyPayload.body_html"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                        />
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="2" header="02. Pricing & Inventory" :style="customStyle">
                    <div class="row" v-if="productDetails.product_type !='M'">
                        <div class="col-md-4 p-2 pl-3">
                            <base-input label="Price">
                                <div class="input-group mb-3">
                                    <input class="form-control form-control-sm" v-model="shopifyPayload.price" min="1" step="0.01" type="number" :disabled="defaultPrice=='R'" required>
                                    <div class="input-group-append d-flex">
                                        <base-dropdown v-model="defaultPrice">
                                            <base-button slot="title" type="secondary"
                                                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                                                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;padding-top: 6px;padding-bottom: 6px;" />
                                            <a class="dropdown-item" v-if="defaultPrice!='R'" @click.prevent="changeDefaultPrice('R')">Retail Price</a>
                                            <a class="dropdown-item"  v-if="defaultPrice!='C'" @click.prevent="changeDefaultPrice('C')">Custom Price</a>
                                        </base-dropdown>
                                    </div>
                                </div>
                            </base-input>
                        </div>
                        <div class="col-md-4 p-2" >
                            <base-input v-model="shopifyPayload.inventory_quantity" input-classes="form-control form-control-sm" min="0" type="number" label="Available Quantity" required disabled/>
                        </div>
                        <div class="col-md-4 p-2">
                            <base-input v-model="shopifyPayload.sku" :disabled="this.$attrs.actionStatus=='Edit'" input-classes="form-control form-control-sm" label="SKU" required/>
                        </div>
                    </div>
                    <div class="row" v-if="productDetails.product_type =='M'">
                        <div class="col-md-12">
                            <base-input label="Default Price" input-classes="form-control form-control-sm">
                            <br>
                            <a-radio-group v-model="defaultPrice">
                                <a-radio-button @click.prevent="changeDefaultPrice('R')" value="R">Retail Price</a-radio-button>
                                <a-radio-button @click.prevent="changeDefaultPrice('C')" value="C">Custom Price</a-radio-button>
                            </a-radio-group>
                            </base-input>
                            <div class="table-responsive">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>SKU</th>
                                            <th>Quantity</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(subProduct,subProductIndex) in productDetails.sub_products" v-bind:key="subProductIndex">
                                            <td>{{subProduct.name}}</td>
                                            <td><base-input v-model="subProduct.stock_no" disabled input-classes="form-control form-control-sm" style="width: 6rem;" required /></td>
                                            <td><base-input disabled min="0" max="5000" type="number" v-model="subProduct.available_quantity" input-classes="form-control form-control-sm" required /></td>
                                            <td><base-input min="1" type="number" :disabled="defaultPrice=='R'" v-model="subProduct.ecom_price" input-classes="form-control form-control-sm" required style="width: 6rem;" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="3" header="03. Delivery" :style="customStyle">
                    <div class="row">
                        <div class="col-4 p-1 pl-3">
                            <base-input v-model="shopifyPayload.weight" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Weight" required/>
                        </div>
                    </div>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import Quill from 'quill'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType','publicUrl']),
        },
        mounted: async function(){
            component_x = this
            var arr = this.$attrs.productIntegrationData
            this.salesChannelId = this.$attrs.salesChannelId
            this.defaultPrice = arr.default_price || "R"
            console.log(arr)
            var id = -1,sales_channel_product_id = -1
            if (this.$attrs.salesChannelStatus == 'Edit'){
                this.shopifyPayload = arr.shopifyParams
                id = arr.product_id
                sales_channel_product_id = arr.id
            }else {
                if (arr.shopifyParams!=undefined && arr.shopifyParams!=null){
                    this.shopifyPayload = arr.shopifyParams
                }else{
                    this.shopifyPayload.title = arr.name
                    this.shopifyPayload.sku = arr.stock_no
                    this.shopifyPayload.price = arr.ecom_price || arr.retail_price
                    this.getProductAvailableQuantity(arr.id)
                    this.shopifyPayload.weight = arr.weight
                    this.shopifyPayload.body_html = arr.extras !=null ? arr.extras.description != null && arr.extras.description!=undefined ? arr.extras.description : null : null
                }
                id = arr.id
                sales_channel_product_id = -1
            }
            if (arr.product_type == "M" && arr.sub_products==undefined){
                var response = await HTTPRequest.getRequest(this.endPoint + 'marketplace_integrations/get_sub_product_details?id='+id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId+'&percent='+this.$attrs.inventoryPercentage+'&sales_channel_product_id='+sales_channel_product_id, null)
                arr.sub_products = response
            }
            this.productDetails = arr
        },
        data(){
            return {
                accessToken:null,
                saveLoading:false,
                categories:[],
                tempCategories:[],
                tempCascaderCategory:[],
                imageUrl:null,
                errors:[],
                activeKey:['1','2','3','4'],
                customStyle:"margin-bottom: 24px;border: 1px solid #dee2e6!important;background-color: #fafafa;",
                logistics:[],
                fetching:false,
                productDetails:[],
                sizeAttributeIndex:-1,
                ColorAttributeIndex:-1,
                salesChannelId:null,
                defaultPrice:null,
                shopifyPayload:{
                    title:null,
                    body_html:null,
                    inventory_quantity:0,
                    sku:null,
                    weight:null,
                    price:null,
                    barcode:null,
                }
            }
        },
        methods: {
            getProductAvailableQuantity: async function(id){
                var response = await HTTPRequest.getRequest(this.endPoint+ 'marketplace_integrations/get_product_stock?id='+id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId, null)
                if (response!=null){
                    if (response["error"] == undefined){
                        this.shopifyPayload.inventory_quantity = (response.available_quantity*this.$attrs.inventoryPercentage)/100
                        this.shopifyPayload.inventory_quantity  = this.shopifyPayload.inventory_quantity<0 ? 0 : this.shopifyPayload.inventory_quantity
                    }else {
                        this.shopifyPayload.inventory_quantity = 0
                    }
                }else{
                    this.shopifyPayload.inventory_quantity = 0
                }
            },
            validation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Product Title', this.shopifyPayload.title));
                if (this.productDetails.product_type == 'M'){
                    //
                }else {
                    this.errors.push(ValidateField.required('SKU', this.shopifyPayload.sku));
                    this.errors.push(ValidateField.required('Price', this.shopifyPayload.price));
                }
                this.errors.push(ValidateField.required('Weight', this.shopifyPayload.weight));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            async saveParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.shopifyParams = this.shopifyPayload
                    this.productDetails.ecom_price = this.shopifyPayload.price
                    this.productDetails.default_price = this.defaultPrice
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.postRequest(this.endPoint+ 'shopify_integrations', null, {sales_channel_id:this.salesChannelId,product_details:this.productDetails})
                        console.log(post_request)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Created."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationAddProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            async updateParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.shopifyParams = this.shopifyPayload
                    this.productDetails.ecom_price = this.shopifyPayload.price
                    this.productDetails.default_price = this.defaultPrice
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.putRequest(this.endPoint+ 'shopify_integrations/'+this.salesChannelId, null, {product_details:this.productDetails})
                        console.log(post_request)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Updated."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationUpdateProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            onEditorBlur(quill) {
                //console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                //console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                //console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
                //console.log('editor change!', quill, html, text)
                // this.LazadaTemplate.Attributes.short_description = html
            },
            changeDefaultPrice(value){
                if (value == 'R'){
                    if (this.productDetails.product_type == 'M'){
                        this.productDetails.sub_products.forEach((value, index) => {
                            this.productDetails.sub_products[index].ecom_price = value.retail_price
                        });
                    }else{
                        this.shopifyPayload.price = this.productDetails.retail_price  
                    }
                }
                this.defaultPrice = value
            },
        }
    };
</script>